import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import CustomDataTable from "../../Components/CustomDataTable";
import GetApiCall from "../../Api/GetApi";
import Notiflix from "notiflix";
import { toast } from "react-toastify";
import { genareteColor } from "../../Helper/GenerateStatusColor";
import { FaCoins, FaGoogleWallet, FaWallet } from "react-icons/fa";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import { Gift, Share, Share2, TrendingUp } from "react-feather";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";
import PostApiCall from "../../Api/Api";

const ReferalList = () => {
  const columnDefs = [
    {
      field: "id",
      header: "S.No",
      sortable: false,
     
      headerStyle: { width: "80px", minWidth: "80px", fontSize: "13px" },
      bodyStyle: { minWidth: "80px", fontSize: "13px", textAlign: "center" },
    }
,    
    {
      field: "fld_name",
      header: "Name",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_credit",
      header: "Reward",
      sortable: true,
      headerStyle: { width: "200px", minWidth: "200px", fontSize: "13px" },
      bodyStyle: { minWidth: "200px", fontSize: "13px" },
    },
    {
      field: "fld_createdAt",
      header: "Added on",
      sortable: true,
      body: (rowData) =>
        moment(rowData?.fld_createdAt).format("DD MMM YYYY") || "",
      headerStyle: { width: "250px", fontSize: "13px" },
      bodyStyle: { minWidth: "250px", fontSize: "13px" },
    },
    {
      field: "fld_status",
      header: "Status",
      sortable: true,
      width: "100px",
      body: (rowData) => (
        <span
          className={`${genareteColor(
            rowData.fld_status
          )} font-size-3 rounded-3 px-2`}
        >
          {rowData.fld_status}
        </span>
      ),
      headerStyle: { width: "100px", fontSize: "13px" },
      bodyStyle: { minWidth: "100px", fontSize: "13px" },
    },
  ];
  const [refresh, setRefresh] = useState(false);
  const [referalList, setReferalList] = useState([]);
  const [totalRewards, setTotalRewards] = useState(0); // State to hold total rewards
  const [availableForRedeem, setAvailableForRedeem] = useState(0); // State to hold available rewards for redemption

  const getRefferalCode = async () => {
    try {
      Notiflix.Loading.standard();

      const resultdes = await GetApiCall.getRequest("GetUserReferById");
      const obj = await resultdes.json();

      if (resultdes.ok) {
        const dd = obj?.data.map((ele, index) => ({ ...ele, id: index + 1 }));

        setReferalList(dd);
        const rewards = obj?.data.reduce(
          (acc, current) => acc + current.fld_credit,
          0
        ); // Assuming 'fld_credit' is the reward amount
        setRefresh(false);
        setTotalRewards(rewards);
        setAvailableForRedeem(rewards); // Assuming all rewards are available for redemption initially
      } else {
        toast.error(obj?.message || "Failed to fetch referral data.", {
          autoClose: delay,
          toastId: 1,
        });
      }
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    } finally {
      Notiflix.Loading.remove();
    }
  };

  const GenerateInvoice = async () => {
    if (referalList?.length) {
      let Id;
      let totalamt;
      let userid;

      let payload = {
        userid: userid,
        auditid: Id,
        invoicetype: "Redeem",
        totalamount: totalamt || 0,
      };

      try {
        Notiflix.Loading.standard();

        const res = await PostApiCall.postRequest(
          payload,
          "JobGenerateInvoice"
        );
        const json = await res.json();

        if (res.ok) {
          toast.success(json.data, {
            autoClose: delay,
          });

          setRefresh(true);
        } else {
          throw new Error(json.data);
        }
        Notiflix.Loading.remove();
      } catch (error) {
        Notiflix.Loading.remove();
        toast.error(error.message || SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
      }
    }
  };

  useEffect(() => {
    getRefferalCode();
  }, [refresh]);

  return (
    <div className="referal-list">
      <div className="p-2">
        {/* Cards for Total Earned and Available for Redeem */}
       
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
          {/* <div
            className="card shadow-sm p-3 me-3 mb-3"
            style={{ minWidth: "200px", flex: "1" }}
          >
            <h6 className="text-muted mb-2">Total Earned</h6>
            <div className="d-flex align-items-center">
              <FaWallet />
              <h4 className="mb-0">$520.00</h4>
            </div>
          </div> */}
          <div
            className="d-flex align-items-center bg-white rounded shadow-sm p-2 w-100 mx-1"
            style={{ minWidth: "200px", flex: "1" }}
          >
            <div
              className="bg-success bg-opacity-50 rounded-pill mr-2"
              style={{ width: "4px", height: "70px" }}
            ></div>
            <div className="d-flex align-items-center">
              <div className="mr-3">
                <FaWallet size={36} color={"green"} />
              </div>
              <div>
                <p className="text-secondary fs-6 mb-1">Total Earned</p>
                <p className="text-dark fs-1 fw-semibold">₹ {totalRewards}</p>
                <div className="text-right">
                  <a
                    target="_blank"
                    href="/refer-earn"
                    className=" btns text-white"
                    style={{ textTransform: "capitalize", fontSize: "10px" }}
                  >
                    Refer a friend
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center bg-white rounded shadow-sm p-2 w-100 mx-1"
            style={{ minWidth: "200px", flex: "1" }}
          >
            <div
              className="bg-info bg-opacity-50 rounded-pill mr-2"
              style={{ width: "4px", height: "70px" }}
            ></div>
            <div className="d-flex align-items-center">
              <div className="mr-3">
                <Gift size={36} color="#6db2c5" />
              </div>
              <div>
                <p className="text-secondary fs-6">Redeemable Balance</p>

                <p className="text-dark d-flex justify-content-between flex-wrap">
                  {" "}
                  <div> ₹ {0}</div>
                  <div>
                    <button
                      // style={{ textTransform: "capitalize",fontSize: "10px", opacity:`${referalList.length > 0?1:0.2}`}}
                      style={{
                        textTransform: "capitalize",
                        fontSize: "10px",
                        opacity: 0.5,
                        borderRadius:4,
                        backgroundColor:PRIMARY_COLOR,
                        color:'white',
                        border:'none'
                      }}
                      // onClick={GenerateInvoice}
                    >
                      Redeem Request
                    </button>
                  </div>
                </p>
                <p className="text-dark" style={{ fontSize: "10px" }}>
                  <strong>Note :</strong> Redeem when the referral completes its
                  first audit
                </p>
              </div>
            </div>
          </div>
          <div
            className="d-flex align-items-center bg-white rounded shadow-sm p-2 w-100 mx-1"
            style={{ minWidth: "200px", flex: "1" }}
          >
            <div
              className="bg-danger bg-opacity-50 rounded-pill mr-4"
              style={{ width: "4px", height: "64px" }}
            ></div>
            <div className="d-flex align-items-center">
              <div className="mr-3">
                <Share2 size={36} color="red" />
              </div>
              <div>
                <p className="text-secondary fs-6 mb-1">Redeemed Amount</p>
                <p className="text-dark fs-1 fw-bold">₹ {0}</p>
                <div></div>
              </div>
            </div>
          </div>

          {/* <div
            className="card shadow-sm p-3 me-3 mb-3"
            style={{ minWidth: "200px", flex: "1" }}
          >
            <h6 className="text-muted mb-2">Available for Redeem</h6>
            <div className="d-flex align-items-center">
              <Share2 />
              <h4 className="mb-0">$120.00</h4>
            </div>
            <p className="text-muted mt-2 mb-0" style={{ fontSize: "0.8rem" }}>
              Redeem after first audit completion
            </p>
          </div>

          <div
            className="card shadow-sm p-3 mb-3"
            style={{ minWidth: "200px", flex: "1" }}
          >
            <h6 className="text-muted mb-2">Already Redeemed</h6>
            <div className="d-flex align-items-center">
              <Gift />
              <h4 className="mb-0">$400.00</h4>
            </div>
          </div> */}
        </div>

        {/* DataTable for Referral List */}
        <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">
          <h5 style={{ color: PRIMARY_TEXT_COLOR }}>Referral List</h5>
        </div>

        <CustomDataTable
          data={referalList}
          columns={columnDefs}
          compact={true} // Enables compact styling
        />
      </div>
    </div>
  );
};

export default ReferalList;

 {/* <Row className="mb-4 g-3">
          <Col sm="4">
            <Card
              className="shadow-sm border-0"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              {" "}
          
              <CardBody className="p-3">
                <div className="d-flex align-items-start gap-3 flex-wrap">
                  <div
                    className="p-3  rounded  mr-2"
                    style={{ backgroundColor: "white" }}
                  >
                    <Share2 className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-muted fw-medium mb-1">Total Earned</p>
                    <h6 className="fs-4 fw-bold text-dark">₹ {totalRewards}</h6>
                    <div className="text-right mt-2">
                  <a
                    target="_blank"
                    href="/refer-earn"
                    className="mt-0 btns text-white"
                    style={{ textTransform: "capitalize", fontSize: "10px" }}
                  >
                    Refer a friend
                  </a>
                </div>
                  </div>

                </div>
                
              </CardBody>
            </Card>
          </Col>
          <Col sm="4">
            <Card
              className="shadow-sm border-0"
              style={{ backgroundColor: "#e2f4ea" }}
            >
              {" "}
             
              <CardBody className="p-3">
                <div className="d-flex align-items-start gap-3 flex-wrap">
                  <div className="p-3  rounded bg-light mr-2">
                    <Gift className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-muted fw-medium mb-1">
                      Available for Redeem
                    </p>
                    <h6 className="fs-4 fw-bold text-dark">
                      ₹ {0}{" "}
                    </h6>
                    <div className="text-right mt-2">
                  <a
                    className="mt-0 btns text-white"
                   
                    // style={{ textTransform: "capitalize",fontSize: "10px", opacity:`${referalList.length > 0?1:0.2}`}}
                    style={{ textTransform: "capitalize",fontSize: "10px", opacity:0.5}}
                    // onClick={GenerateInvoice}
                  >
                    Redeem Request
                  </a>
                </div>
                  </div>
                </div>
               
              </CardBody>
            </Card>
          </Col>
          <Col sm="4">
            <Card
              className="shadow-sm border-0"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              {" "}
              
              <CardBody className="p-3">
                <div className="d-flex align-items-start gap-3 flex-wrap">
                  <div className="p-3  rounded mr-2"  style={{ backgroundColor: "white" }}>
                    <FaWallet size={18} className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <p className="text-muted fw-medium mb-1">
                      Available for Redeem
                    </p>
                    <h6 className="fs-4 fw-bold text-dark">
                      ₹ {0}{" "}
                    </h6>
                    <div className="text-right mt-2">
                  <a
                    className="mt-0 btns text-white"
                   
                    // style={{ textTransform: "capitalize",fontSize: "10px", opacity:`${referalList.length > 0?1:0.2}`}}
                    style={{ textTransform: "capitalize",fontSize: "10px", opacity:0.5}}
                    // onClick={GenerateInvoice}
                  >
                    Redeem Request
                  </a>
                </div>
                  </div>
                </div>
              
              </CardBody>
            </Card>
          </Col>
        </Row> */}
